import React from 'react';

/**
 * FieldSubtext props.
 *
 * @interface FieldSubtextProps
 */
interface FieldSubtextProps {
	/**
	 * Represents the subtext.
	 */
	text: string;
}

/**
 * Component for showing text just below the form fields.
 *
 * @param {RocFieldInfoProps} props
 * @returns
 */
function FieldSubtext(props: FieldSubtextProps) {
	return (
		<small className="input-wrapper__subtext">
			<em>{props.text}</em>
		</small>
	);
}

export default FieldSubtext;
